﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { IWordContainerField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.WordContainerField, eOutputFieldType.wordContainer)
export class WordContainerField extends OutputField implements IWordContainerField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public deleted: boolean;
}
